<template>
  <div class="aside-nav">
    <!-- <div class="operate">
      <a class="btn-link" @click="goMaterialDownload">
        <span class="name">素材下载</span>
      </a>
    </div> -->
    <ul style="margin-top:32px;">
      <li
        class="header-list-item"
        v-for="(item, index) in navs"
        :key="index"
        :class="item.link == currentNav ? 'active' : ''"
        @click="changeNav(item.link)"
      >
        <router-link :to="item.link" v-if="item.link != '11huodong'">
          <img
            :class="
              item.link == 'materialDownload' ||
              item.link == 'pay' ||
              item.link == '11huodong' ||
              item.link == 'materialCenter'
                ? 'iconfontleft'
                : 'iconfontNone'
            "
            :src="item.icon"
          />
          {{ item.name }}
          <!-- <img
            v-if="item.link == 'find'"
            class="iconfont"
            :src="newhot"
            alt
            width="30"
          /> -->
        </router-link>
        <router-link v-else :to="item.link" target="_blank">
          <img
            :class="
              item.link == 'materialDownload' ||
              item.link == 'pay' ||
              item.link == '11huodong' ||
              item.link == 'materialCenter' ||
              item.link == 'activity'
                ? 'iconfontleft'
                : 'iconfontNone'
            "
            :src="item.icon"
          />
          {{ item.name }}
          <img
            v-if="item.link == '11huodong'"
            class="iconfont"
            :src="newhot"
            alt
            width="30"
          />
        </router-link>
        <!-- <div class="line" v-if="index == 5"></div> -->
      </li>
    </ul>
    <!-- 广告图 -->
    <div class="bottom-part">
      <div class="billboards-space">
        <div class="billboards-img">
          <a>
            <img :src="asideBanner" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  setTempUser,
  setToken,
  setNewUser,
  getNewUser,
} from "../../utils/storage";
export default {
  computed: {
    currentNav() {
      return this.$store.state.menu.asideMenuId == null
        ? ""
        : this.$store.state.menu.asideMenuId;
    },
  },
  data() {
    return {
      navs: [], //导航列表
      asideBanner: require("@/assets/images/asideBanner.png"),
      newhot: require("@/assets/images/da_hot.gif"),
    };
  },
  mounted() {
    this.getNavs();
    //监听事件
    this.$EventBus.$on("getNavs", (data) => {
      if (data == "1") {
        this.getNavs();
      }
    });
  },
  destroyed() {
    this.$EventBus.$off("getNavs");
  },
  methods: {
    //获取导航列表
    getNavs() {
      if (
        this.$store.state.common.userInfo.blance !== null &&
        this.$store.state.common.userInfo.blance > 0 &&
        this.$store.state.common.userInfo.gender !== 2
      ) {
        this.navs = this.constants.asideMenus1;
      } else {
        this.navs = this.constants.asideMenus;
      }
    },
    //改变导航菜单时切换状态
    changeNav(index) {
      // if (index == 0) {
      //   this.$store.commit("headerMenuId", 0);
      // } else if (index == 5) {
      //   this.$store.commit("headerMenuId", null);
      // } else if (index == 1) {
      //   this.$store.commit("headerMenuId", 1);
      // } else {
      //   this.$store.commit("headerMenuId", null);
      // }
      this.$store.commit("headerMenuId", index);
      this.$store.commit("asideMenuId", index);
    },
    goMaterialDownload() {
      this.$router.push({ path: "/materialDownload" });
      this.$store.commit("headerMenuId", "materialDownload");
      this.$store.commit("asideMenuId", "materialDownload");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.aside-nav {
  // position: fixed;
  overflow-x: hidden;
  width: 180px;
  position: relative;
  // max-width: 200px;
  height: calc(100vh - 114px);
  background: #fff;
  box-sizing: border-box;
  // z-index: 2;
  .operate {
    width: 100%;
    padding: 40px 0 38px;
    position: relative;
    z-index: 2;
    box-shadow: -4px 2px 12px 0 rgba(0, 0, 0, 0.08);
  }
  .btn-link {
    padding-right: 6px;
    display: flex;
    align-items: center;
    width: 150px;
    height: 38px;
    background: #0773fc;
    border-radius: 4px;
    margin: 0 auto;
    justify-content: center;
    cursor: pointer;
    box-sizing: border-box;
    &:hover {
      background: #0668e3;
    }
    .name {
      color: #fff;
      font-size: 14px;
      font-weight: 700;
    }
  }
  ul {
    height: calc(100vh - 290px);
    min-height: 40px;
    overflow-x: hidden;
    li {
      position: relative;
      width: 100%;
      margin-bottom: 4px;
      cursor: pointer;
      font-size: 14px;
      .line {
        width: 100%;
        height: 1px;
        margin: 10px auto;
        background: #e5e5e5;
      }
      a {
        display: flex;
        align-items: center;
        padding-left: 30px;
        // justify-content: center;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        color: #666;
      }
      &.active {
        a {
          color: rgb(39, 39, 39);
          font-weight: 700;
          background-color: #f4f8ff;
        }
        &::before {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 4px;
          height: 100%;
          background: #0773fc;
          border-radius: 0 4px 4px 0;
        }
      }
      &:hover {
        a {
          background: #ecedf1;
        }
        .iconfont {
          color: rgb(39, 39, 39);
        }
      }
    }
  }

  .iconfont {
    margin-right: 5px;
    vertical-align: center;
    margin-top: -25px;
  }

  .iconfontleft {
    width: 18px;
    height: 18px;
    margin-right: 16px;
    vertical-align: middle;
  }

  .iconfontNone {
    visibility: hidden;
    width: 18px;
    height: 18px;
    margin-right: 16px;
    vertical-align: middle;
  }

  .bottom-part {
    // position: fixed;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    // width: 100%;
    z-index: 2;
    box-shadow: -4px -2px 12px 0 rgba(0, 0, 0, 0.08);
    .billboards-space {
      width: 100%;
      // padding: 12px 0 0 20px;
      padding-bottom: 0;
      box-sizing: border-box;
      .billboards-img {
        width: 150px;
        height: 80px;
        border-bottom: 1px solid #e7e7e7;
        padding-bottom: 12px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        img {
          width: 150px;
          height: 76px;
          border-radius: 4px;
        }
      }
    }
  }

  .banner {
    margin-top: 50px;
    text-align: center;
    img {
      width: 90px;
    }
  }
}
</style>
